import React from 'react';
import './WaitScreen.scss';

export interface WaitScreenProps {
    show: boolean;
    message?: string;
    /**animation delay in seconds, defaults to 0.5 */
    delay?: number;
}

export const WaitScreen: React.FC<WaitScreenProps> = (props) => {
    const { delay } = props;
    const animStyle = {
        animation: `fadein ${delay ? delay.toString() : '0.5'} forwards`
    }
    if (!props.show) return null;

    return (
        <>
            <div className="ts-wait-backdrop" style={animStyle} />
            <div className="ts-wait-content" style={animStyle}>
                <div className="ts-wait-spinner sk-fading-circle" style={animStyle}>
                    <div className="sk-circle1 sk-circle"></div>
                    <div className="sk-circle2 sk-circle"></div>
                    <div className="sk-circle3 sk-circle"></div>
                    <div className="sk-circle4 sk-circle"></div>
                    <div className="sk-circle5 sk-circle"></div>
                    <div className="sk-circle6 sk-circle"></div>
                    <div className="sk-circle7 sk-circle"></div>
                    <div className="sk-circle8 sk-circle"></div>
                    <div className="sk-circle9 sk-circle"></div>
                    <div className="sk-circle10 sk-circle"></div>
                    <div className="sk-circle11 sk-circle"></div>
                    <div className="sk-circle12 sk-circle"></div>
                </div>
                <div className="ts-wait-text" style={animStyle}>{props.message || props.children || ''}</div>
            </div>
        </>

    )
}

(WaitScreen as any).displayName = 'WaitScreen';